import { Alert, Button, Group, Text } from '@mantine/core';
import type { NoticeReason, TrialIntentPrompt } from '../hooks/useTrialIntentAutoStart';

const NOTICES: Record<NoticeReason, string> = {
  already_trialled: 'Your organisation has already used its Guardian trial',
  non_admin: 'Ask your organisation admin to start the Guardian trial',
  unavailable: "The Guardian trial isn't available for your organisation right now",
};

type Props = {
  prompt: TrialIntentPrompt;
  busy: boolean;
  error: string | null;
  onStart: () => void;
  onDismiss: () => void;
};

export function TrialIntentNotice({ prompt, busy, error, onStart, onDismiss }: Readonly<Props>) {
  if (!prompt) return null;

  if (prompt.kind === 'notice') {
    return (
      <Alert color="blue" variant="light" withCloseButton closeButtonLabel="Dismiss" onClose={onDismiss}>
        {NOTICES[prompt.reason]}
      </Alert>
    );
  }

  const retry = prompt.kind === 'retry';
  return (
    <Alert color={retry ? 'red' : 'blue'} variant="light">
      <Group justify="space-between" align="center" wrap="nowrap">
        <Text size="sm">
          {retry ? (error ?? "We couldn't start your Guardian trial. Please try again.") : 'Your Guardian trial is ready to start.'}
        </Text>
        <Button size="xs" loading={busy} onClick={onStart}>
          {retry ? 'Start trial' : 'Start your Guardian trial'}
        </Button>
      </Group>
    </Alert>
  );
}
